export const isParent = (target, parent) => {
  return target === parent || parent?.contains(target);
};
